/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react';

const API_URL = import.meta.env.VITE_API_URL;

function AllBehaviors() {
  const { data, setData } = useDataContext();
  
  // สร้างตัวแปรกันยิงซ้ำ (Protection Flag)
  const hasFetched = useRef(false);

  useEffect(() => {
    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 1: เช็คข้อมูลใน Context (ใส่ ?. กัน Error)
    // -----------------------------------------------------------
    if (data?.allBehaviors && data.allBehaviors.length > 0) {
        return;
    }

    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 2: เช็คว่า Component นี้เคยสั่งยิงไปแล้วหรือยัง?
    // -----------------------------------------------------------
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;

      // เพิ่ม requestOptions ให้เหมือนไฟล์อื่น
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };

      try {
        const response = await fetch(`${API_URL}/behavior/all`, requestOptions);
        const result = await response.json();
        
        setData(prevData => ({ 
            ...prevData, 
            allBehaviors: result.data || [] 
        }));
      } catch (error) {
        console.error("Error fetching behaviors:", error);
        hasFetched.current = false;
      }
    };

    fetchData();
    
    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 3: Dependency Array ต้องว่าง [] 
    // -----------------------------------------------------------
  }, []);

  return null;
}

export default AllBehaviors;
